import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=64478af6&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=64478af6&prod&scoped=true&lang=css&"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=64478af6&prod&lang=css&"
import style2 from "./Onboarding.vue?vue&type=style&index=2&id=64478af6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64478af6",
  null
  
)

export default component.exports